import { render, staticRenderFns } from "./downloadS.vue?vue&type=template&id=433fbd0f&scoped=true&"
import script from "./downloadS.vue?vue&type=script&lang=js&"
export * from "./downloadS.vue?vue&type=script&lang=js&"
import style0 from "./downloadS.vue?vue&type=style&index=0&id=433fbd0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433fbd0f",
  null
  
)

export default component.exports